module.exports = __webpack_public_path__ + "img/yangjiang1.1b82c63d.png";